<div style="border: 2px solid #ddd; padding: 20px; border-radius: 8px; background-color: #f9f9f9; max-width: 450px; margin: 0 auto;border-radius: 7px;">
  <div style="text-align: center; margin-bottom: 20px;">
    <h3 style="color: #333; font-size: 20px; font-weight: 600;">Signature Pad</h3>
    <p style="font-size: 14px; color: #555;">Veuillez signer ci-dessous</p>
  </div>

  <!-- Canvas avec dimensions plus ajustées -->
  <div style="text-align: center;">
    <canvas #canvas width="400" height="200" style="border: 2px solid #000; border-radius: 5px;"></canvas>
  </div>
  
  <!-- Sélection de la couleur du stylo -->
  <div style="margin-top: 20px; text-align: center;">
    <label for="penColor" style="font-size: 16px; color: #333; display: block; margin-bottom: 5px;">Choisissez la couleur</label>
    <input id="penColor" type="color" (input)="changeColor($event)" style="cursor: pointer; border: none; width: 40px; height: 40px; border-radius: 5px;">
  </div>

  <!-- Sélection de la taille du stylo -->
  <div style="margin-top: 20px; text-align: center;">
    <label for="penSize" style="font-size: 16px; color: #333; display: block; margin-bottom: 5px;">Choisissez la taille</label>
    <input id="penSize" type="range" min="1" max="10" [(ngModel)]="penSize" (input)="changeSize()" 
           style="width: 80%; cursor: pointer; background: #ddd; border-radius: 5px; height: 8px;">
  </div>

  <!-- Boutons Effacer et Signer -->
  <div style="margin-top: 20px; text-align: center;">
    <button (click)="clear()" style="padding: 10px 20px; margin-right: 10px; background-color: #f44336; color: white; border: none; border-radius: 5px; cursor: pointer; transition: background-color 0.3s;">
      Effacer
    </button>
    <button (click)="save()" class="btn btn-primary" style="padding: 10px 20px;color: white; border: none; border-radius: 5px; cursor: pointer; transition: background-color 0.3s;">
      Signer
    </button>
  </div>
</div>
